import * as React from 'react';
import * as numeral from 'numeral';
import { PropertyType } from '@beatflyer/shaders-lib';

const KEY_UP = 38;
const KEY_DOWN = 40;
const KEY_ENTER = 13;
const KEY_ESC = 27;

interface Props {
  value: number;
  type: PropertyType;
  minValue: number;
  maxValue: number;
  onChange: (value: number) => void;
}

interface State {
  isEditing: boolean;
  inputValue: string;
}

export class PropertyNumberInput extends React.Component<Props, State> {
  format: string;
  inputEl = React.createRef<HTMLInputElement>();

  state: State = {
    isEditing: false,
    inputValue: ''
  };

  constructor(props: Props) {
    super(props);
    const { minValue, maxValue } = props;
    this.format = maxValue - minValue < 2 ? '0.[000]' : '0.[00]';
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.isEditing !== this.state.isEditing && this.state.isEditing) {
      this.inputEl.current?.select();
    }
  }

  didChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.trim();
    this.setState({ inputValue: value });
    if (value.length === 0) {
      return;
    }
    if (value.endsWith('.') || value.endsWith(',')) {
      return;
    }
    let newValue = parseFloat(value);
    if (isNaN(newValue)) {
      return;
    }
    const { minValue, maxValue } = this.props;
    newValue = Math.max(minValue, Math.min(maxValue, newValue));
    this.props.onChange(newValue);
  };

  startEdit = () => {
    this.setState({
      isEditing: true,
      inputValue: this.formatValue(this.props.value)
    });
  };

  stopEdit = () => {
    this.setState({ isEditing: false });
  };

  didKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    // console.log(event.keyCode);
    switch (event.keyCode) {
      case KEY_UP:
        this.nudge(event.shiftKey ? 10 : 1);
        break;
      case KEY_DOWN:
        this.nudge(event.shiftKey ? -10 : -1);
        break;
      case KEY_ENTER:
      case KEY_ESC:
        this.setState({ isEditing: false });
        break;
      default:
        break;
    }
  };

  nudge = (delta: number) => {
    const { minValue, maxValue } = this.props;
    let newValue = parseFloat(this.state.inputValue);
    newValue += delta;
    newValue = Math.max(minValue, Math.min(maxValue, newValue));
    this.setState({ inputValue: this.formatValue(newValue) });
    this.props.onChange(newValue);
  };

  formatValue = (value: number): string => {
    const { type } = this.props;
    return type === PropertyType.INT
      ? Math.round(value) + ''
      : numeral(value).format(this.format);
  };

  render() {
    const { isEditing, inputValue } = this.state;
    if (isEditing) {
      return (
        <input
          className="custom-property-value"
          type="text"
          value={inputValue}
          onChange={this.didChangeValue}
          onBlur={this.stopEdit}
          ref={this.inputEl}
          onKeyDown={this.didKeyDown}
        />
      );
    }
    return (
      <span className="custom-property-value" onClick={this.startEdit}>
        {this.formatValue(this.props.value)}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controller/CustomPropertyNumberInput.tsx